import { render, staticRenderFns } from "./language-tabs.vue?vue&type=template&id=3eb91adb"
import script from "./language-tabs.vue?vue&type=script&lang=js"
export * from "./language-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports